import React from "react";

const RecipeMenuModal = ({ recipeData }) => {
  return (
    <div
      className="modal fade recipe-menu-modal"
      id="recipeMenuModal"
      tabIndex="-1"
      aria-labelledby="recipeMenuModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" tabIndex="0">
            <div className="modal-heading">Recipe Menu</div>

            {recipeData.length > 0 &&
              recipeData.map((item, ind) => (
                <div
                  className="mb-3 recipe-menu-modal-content-wrapper"
                  key={ind}
                >
                  <div className="recipe-menu-modal-head">
                    {item.recipeName}
                  </div>
                  <div className="recipe-menu-modal-sub-head">
                    by {item.chefName}{" "}
                    <a
                      href={item.chefInstaIdLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ({item.chefInstaId})
                    </a>{" "}
                    on Instagram
                  </div>
                  <div className="recipe-menu-modal-link">
                    <a
                      href={item.recipeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.recipeLinkText}
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipeMenuModal;
